export default "__VITE_ASSET__DF4y5D88__"